module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_8.644f203a.jpg";